export default __webpack_public_path__ + "static/media/download.67626ae8.png";